<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Displays a graph based on the provided url
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <log-back-in-modal ref="logInModal"
            :get-route="getLoginModalRoute"
        ></log-back-in-modal>
    </div>
</template>

<script>
    export default{
        props: {
            jobRouteIn: {
                type: String,
                default: ''
            },
            loginModalRouteIn: {
                type: String,
                default: ''
            },
            data: {
                type: Object
            }
        },
        mounted() {
            var self = this;
            //add in a check to alert the user something hasn't been auto saved
            window.addEventListener("beforeunload", function (e) {
                var saving = self.checkAutoSaveJobs(true);
                if (!saving) {
                    return undefined;
                }
                
                //custom messages don't work in most modern browswers, but left it in just in case.
                var confirmationMessage = 'It looks like you have changed something that has not yet been saved. Are you sure you want to leave the page?';

                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            });
            document.addEventListener("visibilitychange", () => {
                if (!document.hidden) {
                    if(self.$refs.logInModal !== undefined){
                        self.$refs.logInModal.closeModal();
                    }
                }
            });
        },
        data() {
            return {
                jobRoute: this.data !== undefined && this.data.jobRouteIn !== undefined ? this.data.jobRouteIn : this.jobRouteIn,
                getLoginModalRoute: this.data !== undefined && this.data.getLoginModalRoute !== undefined ? this.data.getLoginModalRoute : this.loginModalRouteIn,
                errorOccured: false,
                listenJobId: null,
                jobs: [],
                jobsCurr: [],
                runningJob: false,
                timerIndex: 0,
                timerLengths: [2000,2000,3000,3000,5000,5000,5000,5000,10000],
                currAutoSaveJobs: [],
                loadingAutoSaveJobs: false,
                autoSaveCountdown: 120,
            }
        },
        computed: {
            watchArray: function(){
                var arr = [];
                for(var i=0; i<this.currAutoSaveJobs.length; i++){
                    arr.push(this.getAutoSaveValue(this.currAutoSaveJobs[i]));
                }
                return arr;
            }
        },
        methods: {
            /**
             * this job listens to the currently active job and provides an update based on the results
             * 
             * @param data the data it is listening for
             * 
             * @return Array an array of attendance
             */
            listenJob: async function() {
                if(this.$reportJobs.length == 0){
                    this.runningJob = false;
                } else {
                    this.jobsCurr = [];
                    try {
                        var newJobs = [];
                        var limit = this.$reportJobs.length;
                        if(limit > 10){
                            limit = 10;
                        }
                        for(var i=0; i<limit; i++){
                            newJobs.push({
                                jobId: this.$reportJobs[i].jobId,
                                studentId: this.$reportJobs[i].studentId,
                                graph: this.$reportJobs[i].graph,
                                exportJob: this.$reportJobs[i].exportJob,
                                startJob: this.$reportJobs[i].startJob,
                                editableFormJob: this.$reportJobs[i].editableFormJob,
                                toDoListJob: this.$reportJobs[i].toDoListJob,
                                customJob: this.$reportJobs[i].customJob,
                                autoCompleteJob: this.$reportJobs[i].autoCompleteJob,
                                logic: this.$reportJobs[i].logic,
                                method: this.$reportJobs[i].method,
                                methodTotal: this.$reportJobs[i].methodTotal,
                                methodReturn: this.$reportJobs[i].methodReturn,
                                params: this.$reportJobs[i].params,
                                autoSaveName: this.$reportJobs[i].autoSaveName,
                                autoSaveJob: this.$reportJobs[i].autoSaveJob,
                                checkLoggedInJob: this.$reportJobs[i].checkLoggedInJob
                            });
                            this.jobsCurr.push(this.$reportJobs[i]);
                        }
                        if(this.jobsCurr.length >= this.$reportJobs.length){
                            this.$reportJobs = [];
                        } else {
                            this.timerIndex = 1;
                            this.$reportJobs.splice(0, this.jobsCurr.length);
                        }
                        var params = {
                            'jobs': JSON.stringify(newJobs),
                        };
                        const { data } = await this.$http.post(this.jobRoute, params);
                        if(data.error !== undefined && data.error.length > 0){
                            this.errorOccured = true;
                            console.log('An error occurred reading the graph jobs');
                            console.log(data.error);
                            this.runningJob = false;
                            try {
                                for(var i=0; i<this.jobsCurr.length; i++){
                                    try {
                                        if(this.jobsCurr[i].autoSaveName !== undefined && this.jobsCurr[i].autoSaveName !== null){
                                            this.autoSaveError({error: 'An error occurred reading the graph jobs'}, this.jobsCurr[i].autoSaveName);
                                        } else if(this.jobsCurr[i].object !== undefined && this.jobsCurr[i].object !== null) {
                                            this.jobsCurr[i].object.setJobError({error: 'An error occurred reading the graph jobs'});
                                        }
                                    } catch(error) {
                                        console.log('An error occurred setting the error for an individual job');
                                        if(error.response !== undefined){
                                            console.log('File: ' + error.response.data.file);
                                            console.log('Line: ' + error.response.data.line);
                                            console.log('Message: ' + error.response.data.message);
                                            console.log('Exception: ' + error.response.data.exception);
                                            console.log(error.response.data.trace);
                                        } else {
                                            console.log(error);
                                        }
                                    }
                                }
                            } catch(error) {
                                console.log('An error occurred setting the error for an individual job');
                                if(error.response !== undefined){
                                    console.log('File: ' + error.response.data.file);
                                    console.log('Line: ' + error.response.data.line);
                                    console.log('Message: ' + error.response.data.message);
                                    console.log('Exception: ' + error.response.data.exception);
                                    console.log(error.response.data.trace);
                                } else {
                                    console.log(error);
                                }
                            }
                            if(this.$reportJobs.length > 0){
                                this.reportJobsChanged();
                            }
                        } else {
                            this.setJobs(data);
                        }
                    } catch(error) {
                        this.errorOccured = true;
                        console.log(error);
                        console.log('An error occurred reading the graph jobs');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                        this.runningJob = false;
                        if(error.request !== undefined && error.request.status == 401){
                            this.userIsLoggedOut();
                        }
                        
                        try {
                            for(var i=0; i<this.jobsCurr.length; i++){
                                try {
                                    if(this.jobsCurr[i].checkLoggedInJob){
                                        
                                    } else if(this.jobsCurr[i].autoSaveName !== undefined && this.jobsCurr[i].autoSaveName !== null){
                                        this.autoSaveError({error: 'An error occurred reading the graph jobs'}, this.jobsCurr[i].autoSaveName);
                                    } else if(this.jobsCurr[i].object !== undefined && this.jobsCurr[i].object !== null) {
                                        this.jobsCurr[i].object.setJobError({error: 'An error occurred reading the graph jobs'});
                                    }
                                } catch(error) {
                                    console.log('An error occurred setting the error for an individual job');
                                    if(error.response !== undefined){
                                        console.log('File: ' + error.response.data.file);
                                        console.log('Line: ' + error.response.data.line);
                                        console.log('Message: ' + error.response.data.message);
                                        console.log('Exception: ' + error.response.data.exception);
                                        console.log(error.response.data.trace);
                                    } else {
                                        console.log(error);
                                    }
                                }
                            }
                        } catch(error) {
                            console.log('An error occurred setting the error');
                            if(error.response !== undefined){
                                console.log('File: ' + error.response.data.file);
                                console.log('Line: ' + error.response.data.line);
                                console.log('Message: ' + error.response.data.message);
                                console.log('Exception: ' + error.response.data.exception);
                                console.log(error.response.data.trace);
                            } else {
                                console.log(error);
                            }
                        }
                        if(this.$reportJobs.length > 0){
                            this.reportJobsChanged();
                        }
                    }
                }
            },
            /**
             * this sets the graph to the current results of the job
             * 
             * @param data the data it is listening for
             * 
             * @return Array an array of attendance
             */
            setJobs: async function(data) {
                var jobIdsDone = [];
                var jobsActuallyUsed = [];
                var thereWasAnError = null;
                for(var i=0; i<data.length; i++){
                    try{
                        if(!jobIdsDone.includes(data[i].jobId + '_' + data[i].graph)){
                            var jobObs = [];
                            var checkLoggedInJob = false;
                            for(var j=0; j<this.jobsCurr.length; j++){
                                if(this.jobsCurr[j].startJob !== undefined && this.jobsCurr[j].startJob && this.jobsCurr[j].graph == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].exportJob !== undefined && this.jobsCurr[j].exportJob && 'export:' + this.jobsCurr[j].method == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].toDoListJob !== undefined && this.jobsCurr[j].toDoListJob && 'todolist' == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].customJob !== undefined && this.jobsCurr[j].customJob && ('custom:' + this.jobsCurr[j].method + '_' + this.jobsCurr[j].logic) == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].autoCompleteJob !== undefined && this.jobsCurr[j].autoCompleteJob && 'autocomplete:' + this.jobsCurr[j].method + ':' + this.jobsCurr[j].params.search == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].editableFormJob !== undefined && this.jobsCurr[j].editableFormJob && 'editableforms' == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                //job may have changed, so check the old job id
                                } else if(this.jobsCurr[j].jobId == data[i].oldJobId && this.jobsCurr[j].graph == data[i].graph){
                                    jobObs.push(this.jobsCurr[j]);
                                } else if(this.jobsCurr[j].checkLoggedInJob){
                                    checkLoggedInJob = true;
                                }
                            }
                            jobIdsDone.push(data[i].jobId + '_' + data[i].graph);
                            if(jobObs.length > 0){
                                for(var k=0; k<jobObs.length; k++){
                                    jobsActuallyUsed.push(k);
                                    var complete = this.setJob(data[i], jobObs[k].object, jobObs[k].readOnlyParams, jobObs[k]);
                                }
                            } else if(checkLoggedInJob){
                                
                            } else {
                                if(data[i].error !== undefined && data[i].error.length > 0){
                                    thereWasAnError = data[i];
                                }
                                console.log('error updating this job, couldnt find an object');
                                console.log(data[i]);
                            }
                        }
                    } catch(error) {
                        this.errorOccured = true;
                        console.log('An error occurred setting the graph jobs');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }
                }
                if(thereWasAnError !== null){
                    for(var j=0; j<this.jobsCurr.length; j++){
                        if(!jobsActuallyUsed.includes(j)){
                            var complete = this.setJob(thereWasAnError, this.jobsCurr[j].object, this.jobsCurr[j].readOnlyParams, this.jobsCurr[j]);
                        }
                    }
                }
                if(this.$reportJobs.length > 0){
                    this.listenJobId = setTimeout(() => this.listenJob(), this.timerIndex < this.timerLengths.length ? this.timerLengths[this.timerIndex] : this.timerLengths[this.timerLengths.length-1]);
                    this.timerIndex++;
                } else {
                    this.runningJob = false;
                }
            },
            /**
             * this sets the graph to the current results of the job
             * 
             * @param data the data it is listening for
             * 
             * @return Array an array of attendance
             */
            setJob: async function(data, object, readOnlyParams, jobOb) {
                if(jobOb.autoSaveName !== undefined && jobOb.autoSaveName !== null){
                } else if(typeof object.setJobProgress === 'function'){
                    object.setJobProgress(data, readOnlyParams);
                }
                if(data.error !== undefined && data.error.length > 0){
                    if(jobOb.autoSaveName !== undefined && jobOb.autoSaveName !== null){
                        this.autoSaveError(data, jobOb.autoSaveName);
                    } else if(typeof object.setJobError === 'function'){
                        
                        object.setJobError(data, readOnlyParams);
                    }
                    return false;
                }
                if(data.graphData !== undefined || data.progress >= data.total){
                    if(data.graphData.error !== undefined && data.graphData.error !== null && data.graphData.error.length > 0){
                        if(jobOb.autoSaveName !== undefined && jobOb.autoSaveName !== null){
                            this.autoSaveError(data.graphData, jobOb.autoSaveName);
                        } else if(typeof object.setJobError === 'function'){
                            object.setJobError(data.graphData, readOnlyParams);
                        }
                        return false;
                    }
                    if(jobOb.autoSaveName !== undefined && jobOb.autoSaveName !== null){
                        this.autoSaveComplete(data, jobOb.autoSaveName);
                    } else if(typeof object.setJobComplete === 'function'){
                        object.setJobComplete(data, readOnlyParams);
                    }
                } else if(this.jobRoute.length > 0 && !this.error_occured){
                    data = {...data};
                    data.object = object;
                    data.readOnlyParams = readOnlyParams;
                    data.autoSaveName = jobOb.autoSaveName;
                    this.$reportJobs.push(data);
                } else if(data.error === undefined || data.error.length == 0) {
                    if(jobOb.autoSaveName !== undefined && jobOb.autoSaveName !== null){
                        this.autoSaveError(data, jobOb.autoSaveName);
                    } else if(typeof object.setJobError === 'function'){
                        object.setJobError(data, readOnlyParams);
                    }
                }
            },
            loadAutoSaveJobs: function() {
                for(var i=0; i<this.$autoSaveJobs.length; i++){
                    var alreadyExists = this.hasAutoJobAlready(this.$autoSaveJobs[i].name);
                    if(alreadyExists >= 0){
                        if(this.$autoSaveJobs[i].action !== undefined && this.$autoSaveJobs[i].action == 'save'){
                            this.doAutoSave(alreadyExists);
                        } else if(this.$autoSaveJobs[i].action !== undefined && this.$autoSaveJobs[i].action == 'cancel'){
                            this.currAutoSaveJobs[alreadyExists].changed = false;
                            this.currAutoSaveJobs[alreadyExists].autoSaveObject.changed = false;
                            if(this.currAutoSaveJobs[alreadyExists].interval !== null){
                                clearInterval(this.currAutoSaveJobs[alreadyExists].interval);
                                this.currAutoSaveJobs[alreadyExists].interval = null;
                            }
                        } else {
                            if(this.$autoSaveJobs[i].reset){
                                this.$autoSaveJobs[i].checksum = this.getCheckSum(this.getAutoSaveValue(this.$autoSaveJobs[i]));
                                this.$autoSaveJobs[i].changed = false;
                                this.$autoSaveJobs[i].saving = false;
                                this.$autoSaveJobs[i].countdown = this.autoSaveCountdown;
                                this.$autoSaveJobs[i].interval = null;
                                this.$autoSaveJobs[i].autoSaveObject.progressJob = this;
                                this.currAutoSaveJobs[alreadyExists] = this.$autoSaveJobs[i];
                            } else {
                                this.currAutoSaveJobs[alreadyExists].autoSaveObject = this.$autoSaveJobs[i].autoSaveObject;
                                this.currAutoSaveJobs[alreadyExists].object = this.$autoSaveJobs[i].object;
                                this.currAutoSaveJobs[alreadyExists].variable = this.$autoSaveJobs[i].variable;
                                this.currAutoSaveJobs[alreadyExists].autoSaveObject.changed = this.currAutoSaveJobs[alreadyExists].changed;
                                this.currAutoSaveJobs[alreadyExists].autoSaveObject.saving = this.currAutoSaveJobs[alreadyExists].saving;
                                this.currAutoSaveJobs[alreadyExists].autoSaveObject.countdown = this.currAutoSaveJobs[alreadyExists].countdown;
                                this.currAutoSaveJobs[alreadyExists].autoSaveObject.progressJob = this;
                                this.currAutoSaveJobs[alreadyExists].checksum = this.getCheckSum(this.getAutoSaveValue(this.currAutoSaveJobs[alreadyExists]));
                            }
                        }
                    } else {
                        this.$autoSaveJobs[i].checksum = this.getCheckSum(this.getAutoSaveValue(this.$autoSaveJobs[i]));
                        this.$autoSaveJobs[i].changed = false;
                        this.$autoSaveJobs[i].saving = false;
                        this.$autoSaveJobs[i].countdown = this.autoSaveCountdown;
                        this.$autoSaveJobs[i].interval = null;
                        this.$autoSaveJobs[i].autoSaveObject.progressJob = this;
                        this.currAutoSaveJobs.push(this.$autoSaveJobs[i]);
                    }
                }
                this.$autoSaveJobs = [];
                this.loadingAutoSaveJobs = false;
            },
            checkAutoSaveJobs: function(force=false){
                var saving = false;
                for(var i=0; i<this.currAutoSaveJobs.length; i++){
                    var newChecksum = this.getCheckSum(this.getAutoSaveValue(this.currAutoSaveJobs[i]));
                    if(this.currAutoSaveJobs[i].checksum != newChecksum){
                        this.currAutoSaveJobs[i].checksum = newChecksum;
                        this.startAutoSaveCountDown(i, this.autoSaveCountdown);
                        saving = true;
                    } else if(this.currAutoSaveJobs[i].saving || this.currAutoSaveJobs[i].changed || this.currAutoSaveJobs[i].autoSaveObject.error){
                        saving = true;
                        if(force){
                            this.doAutoSave(i);
                        }
                    }
                }
                return saving;
            },
            startAutoSaveCountDown: function(i, countdown=120, force=false){
                if(!this.currAutoSaveJobs[i].changed || force){
                    this.currAutoSaveJobs[i].changed = true;
                    this.currAutoSaveJobs[i].countdown = countdown;
                    if(this.currAutoSaveJobs[i].autoSaveObject !== undefined && this.currAutoSaveJobs[i].autoSaveObject !== null){
                        this.currAutoSaveJobs[i].autoSaveObject.changed = true;
                        this.currAutoSaveJobs[i].autoSaveObject.countdown = countdown;
                    }
                    var self = this;
                    if(this.currAutoSaveJobs[i].interval !== null){
                        clearInterval(this.currAutoSaveJobs[i].interval);
                        this.currAutoSaveJobs[i].interval = null;
                    }
                    var name = this.currAutoSaveJobs[i].autoSaveObject.name;
                    this.currAutoSaveJobs[i].interval = setInterval(function(){
                        if(self.currAutoSaveJobs[i].countdown <= 1){
                            clearInterval(self.currAutoSaveJobs[i].interval);
                            self.currAutoSaveJobs[i].interval = null;
                            self.doAutoSave(i);
                        } else {
                            self.currAutoSaveJobs[i].countdown -= 1;
                            if(self.currAutoSaveJobs[i].autoSaveObject !== undefined && self.currAutoSaveJobs[i].autoSaveObject !== null && self.currAutoSaveJobs[i].autoSaveObject.name == name){
                                self.currAutoSaveJobs[i].autoSaveObject.countdown = self.currAutoSaveJobs[i].countdown;
                            }
                        }
                    }, 1000);
                }
            },
            doAutoSave: function(i){
                if(this.currAutoSaveJobs[i].changed && !this.currAutoSaveJobs[i].saving){
                    if(this.currAutoSaveJobs[i].autoSaveObject !== undefined && this.currAutoSaveJobs[i].autoSaveObject !== null){
                        //this.currAutoSaveJobs[i].saving = true;
                        //this.currAutoSaveJobs[i].autoSaveObject.saving = true;
                        /*this.$reportJobs.push({
                            customJob: true,
                            logic: this.currAutoSaveJobs[i].jobParams.logic,
                            method: this.currAutoSaveJobs[i].jobParams.method,
                            methodTotal: this.currAutoSaveJobs[i].jobParams.methodTotal,
                            methodReturn: this.currAutoSaveJobs[i].jobParams.methodReturn,
                            params: this.getAutoSaveValue(this.currAutoSaveJobs[i]),
                            autoSaveJob: true,
                            autoSaveName: this.currAutoSaveJobs[i].name
                        });*/
                        this.$reportJobs.push({
                            checkLoggedInJob: true,
                        });
                        this.currAutoSaveJobs[i].changed = false;
                        //this.currAutoSaveJobs[i].autoSaveObject.changed = false;
                        this.startAutoSaveCountDown(i);
                    }
                } else if(this.currAutoSaveJobs[i].changed && this.currAutoSaveJobs[i].saving){
                    this.startAutoSaveCountDown(i, 10, true);
                }
            },
            autoSaveComplete: function(data, name){
                var jobId = this.hasAutoJobAlready(name);
                this.currAutoSaveJobs[jobId].saving = false;
                if(this.currAutoSaveJobs[jobId].autoSaveObject.name == name){
                    this.currAutoSaveJobs[jobId].autoSaveObject.saving = false;
                    this.currAutoSaveJobs[jobId].autoSaveObject.error = false;
                }
                this.currAutoSaveJobs[jobId].object.autoSaveComplete(data);
            },
            autoSaveError: function(data, name){
                console.log('an error occurred auto saving');
                console.log(data.error);
                console.log(data);
                var jobId = this.hasAutoJobAlready(name);
                this.currAutoSaveJobs[jobId].saving = false;
                if(this.currAutoSaveJobs[jobId].autoSaveObject.name == name){
                    this.currAutoSaveJobs[jobId].autoSaveObject.saving = false;
                    this.currAutoSaveJobs[jobId].autoSaveObject.error = true;
                }
            },
            hasAutoJobAlready: function(name){
                for(var i=0; i<this.currAutoSaveJobs.length; i++){
                    if(this.currAutoSaveJobs[i].name == name){
                        return i;
                    }
                }
                return -1;
            },
            reportJobsChanged: function(){
                if(!this.runningJob){
                    this.timerIndex = 0;
                    this.runningJob = true;
                    this.listenJobId = setTimeout(() => this.listenJob(), 500);
                }
            },
            autoSaveJobsChanged: function(){
                if(!this.loadingAutoSaveJobs && this.$autoSaveJobs.length > 0){
                    this.loadingAutoSaveJobs = true;
                    this.loadAutoSaveJobs();
                }
            },
            getAutoSaveValue: function(job){
                if(job.variable.constructor === Array){
                    var ret = job.object;
                    for(var i=0; i<job.variable.length; i++){
                        ret = ret[job.variable[i]];
                    }
                    return ret;
                } else {
                    return job.object[job.variable];
                }
            },
            getCheckSum: function(variable){
                return JSON.stringify(variable);
            },
            userIsLoggedOut: function(){
                this.$refs.logInModal.showModal();
            }
        },
        watch: {
            /**
             * Handle changes to jobs
             */
            $reportJobs: function() {
                this.reportJobsChanged();
            },
            /**
             * Handle changes to jobs
             */
            $autoSaveJobs: function() {
                this.autoSaveJobsChanged();
            },
            watchArray: {
                handler() {
                    this.checkAutoSaveJobs();
                },
                deep: true
            }
        },
        destroyed() {
            if(this.listenJobId !== null){
                clearTimeout(this.listenJobId);
                this.listenJobId = null;
            }
        }
    }
</script>